export default __webpack_public_path__ + "static/media/small-circle.97c6f5ef.svg";